import { constructionConstants } from "@constants";

const initialState = {
  loginInfo: {
    data: null,
    loading: false,
    fail: null
  },
  events: {
    items: [],
    loading: false,
    fail: null
  },
  searchTarget: {
    items: [],
    loading: false,
    fail: null
  },
  summaries: {
    data: {},
    loading: false,
    fail: null
  },
  setting: {
    processing: false,
    fail: null
  },
  getEdit: {
    loading: false,
    fail: null
  },
  paymentMethodList: {
    items: [],
    loading: false,
    fail: null
  },
  parkingSpacePatternList: {
    items: [],
    loading: false,
    fail: null
  },
  householdMeta: {
    data: {},
    loading: false,
    fail: null
  },
  storeAreas: {
    data: [],
    loading: false,
    fail: null
  },
  userList: {
    items: [],
    loading: false,
    fail: null
  },
  parkingSpaceList: {
    items: [],
    loading: false,
    fail: null
  }
};

export const construction = (state = initialState, action) => {
  switch (action.type) {
    case constructionConstants.GET_LOGIN_INFO_REQUEST:
      return {
        ...state,
        loginInfo: {
          ...initialState.loginInfo,
          loading: true
        }
      };
    case constructionConstants.GET_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        loginInfo: {
          ...initialState.loginInfo,
          loading: false,
          data: action.loginInfo
        }
      };
    case constructionConstants.GET_LOGIN_INFO_FAILURE:
      return {
        ...state,
        loginInfo: {
          ...initialState.loginInfo,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.GET_EVENTS_REQUEST:
      return {
        ...state,
        events: {
          ...initialState.events,
          loading: true
        }
      };
    case constructionConstants.GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: {
          ...initialState.events,
          loading: false,
          items: action.events
        }
      };
    case constructionConstants.GET_EVENTS_FAILURE:
      return {
        ...state,
        events: {
          ...initialState.events,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: initialState.events
      };
    case constructionConstants.SEARCH_TARGET_REQUEST:
      return {
        ...state,
        searchTarget: {
          ...initialState.searchTarget,
          loading: true,
          fail: null
        }
      };
    case constructionConstants.SEARCH_TARGET_SUCCESS:
      return {
        ...state,
        searchTarget: {
          ...initialState.searchTarget,
          loading: false,
          items: action.items
        }
      };
    case constructionConstants.SEARCH_TARGET_FAILURE:
      return {
        ...state,
        searchTarget: {
          ...initialState.searchTarget,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_SEARCH_TARGET_SUCCESS:
      return {
        ...state,
        searchTarget: initialState.searchTarget
      };
    case constructionConstants.GET_SUMMARIES_REQUEST:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          loading: true,
          fail: null
        }
      };
    case constructionConstants.GET_SUMMARIES_SUCCESS:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          loading: false,
          data: action.summaries
        }
      };
    case constructionConstants.GET_SUMMARIES_FAILURE:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.REFRESH_SUMMARIES_SUCCESS:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          loading: false,
          data: action.summaries
        }
      };
    case constructionConstants.REFRESH_SUMMARIES_FAILURE:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_SUMMARIES_SUCCESS:
      return {
        ...state,
        summaries: initialState.summaries
      };
    case constructionConstants.SETTING_REQUEST:
      return {
        ...state,
        setting: {
          ...initialState.setting,
          processing: true
        }
      };
    case constructionConstants.SETTING_SUCCESS:
      return {
        ...state,
        setting: {
          ...initialState.setting,
          processing: false
        }
      };
    case constructionConstants.SETTING_FAILURE:
      return {
        ...state,
        setting: {
          ...initialState.setting,
          processing: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_SETTING_SUCCESS:
      return {
        ...state,
        setting: initialState.setting
      };
    case constructionConstants.GET_EDIT_REQUEST:
      return {
        ...state,
        getEdit: {
          ...initialState.getEdit,
          loading: true
        }
      };
    case constructionConstants.GET_EDIT_SUCCESS:
      return {
        ...state,
        getEdit: {
          ...state.getEdit,
          loading: false
        }
      };
    case constructionConstants.GET_EDIT_FAILURE:
      return {
        ...state,
        getEdit: {
          ...initialState.getEdit,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_GET_EDIT_SUCCESS:
      return {
        ...state,
        getEdit: initialState.getEdit
      };
    case constructionConstants.GET_PAYMENT_METHOD_LIST_REQUEST:
      return {
        ...state,
        paymentMethodList: {
          ...initialState.paymentMethodList,
          loading: true
        }
      };
    case constructionConstants.GET_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,
        paymentMethodList: {
          ...state.paymentMethodList,
          loading: false,
          items: action.paymentMethods
        }
      };
    case constructionConstants.GET_PAYMENT_METHOD_LIST_FAILURE:
      return {
        ...state,
        paymentMethodList: {
          ...initialState.paymentMethodList,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_GET_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,
        paymentMethodList: initialState.paymentMethodList
      };
    case constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_REQUEST:
      return {
        ...state,
        parkingSpacePatternList: {
          ...initialState.parkingSpacePatternList,
          loading: true
        }
      };
    case constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_SUCCESS:
      return {
        ...state,
        parkingSpacePatternList: {
          ...state.parkingSpacePatternList,
          loading: false,
          items: action.parkingSpacePatterns
        }
      };
    case constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_FAILURE:
      return {
        ...state,
        parkingSpacePatternList: {
          ...initialState.parkingSpacePatternList,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_GET_PARKING_SPACE_PATTERN_LIST_SUCCESS:
      return {
        ...state,
        parkingSpacePatternList: initialState.parkingSpacePatternList
      };
    case constructionConstants.GET_HOUSEHOLD_META_REQUEST:
      return {
        ...state,
        householdMeta: {
          ...initialState.householdMeta,
          loading: true
        }
      };
    case constructionConstants.GET_HOUSEHOLD_META_SUCCESS:
      return {
        ...state,
        householdMeta: {
          ...state.householdMeta,
          loading: false,
          data: action.householdMeta
        }
      };
    case constructionConstants.GET_HOUSEHOLD_META_FAILURE:
      return {
        ...state,
        householdMeta: {
          ...initialState.householdMeta,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_HOUSEHOLD_META_SUCCESS:
      return {
        ...state,
        householdMeta: initialState.householdMeta
      };
    case constructionConstants.GET_STORE_AREA_LIST_REQUEST:
      return {
        ...state,
        storeAreas: {
          loading: true
        }
      };
    case constructionConstants.GET_STORE_AREA_LIST_SUCCESS:
      return {
        ...state,
        storeAreas: {
          loading: false,
          data: action.storeAreas
        }
      };
    case constructionConstants.GET_STORE_AREA_LIST_FAILURE:
      return {
        ...state,
        storeAreas: {
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_STORE_AREA_LIST_SUCCESS:
      return {
        ...state,
        storeAreas: initialState.storeAreas
      };
    case constructionConstants.GET_USER_LIST_REQUEST:
      return {
        ...state,
        userList: {
          ...initialState.userList,
          loading: true
        }
      };
    case constructionConstants.GET_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: false,
          items: action.users
        }
      };
    case constructionConstants.GET_USER_LIST_FAILURE:
      return {
        ...state,
        userList: {
          ...initialState.userList,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: initialState.userList
      };
    case constructionConstants.GET_PARKING_SPACE_LIST_REQUEST:
      return {
        ...state,
        parkingSpaceList: {
          ...initialState.parkingSpaceList,
          loading: true
        }
      };
    case constructionConstants.GET_PARKING_SPACE_LIST_SUCCESS:
      return {
        ...state,
        parkingSpaceList: {
          ...state.parkingSpaceList,
          loading: false,
          items: action.parkingSpaces
        }
      };
    case constructionConstants.GET_PARKING_SPACE_LIST_FAILURE:
      return {
        ...state,
        parkingSpaceList: {
          ...initialState.parkingSpaceList,
          loading: false,
          fail: action.error
        }
      };
    case constructionConstants.RESET_PARKING_SPACE_LIST_SUCCESS:
      return {
        ...state,
        parkingSpaceList: initialState.parkingSpaceList
      };
    default:
      return state;
  }
};
